module.exports = __webpack_public_path__ + "static/media/phone_1.c4e4a3d7.png";